const NOT_SPECIFIED = 'Not specified' as const;

const formatOptional = (value: string | null | undefined): string =>
  value?.trim() || NOT_SPECIFIED;

export { formatOptional, NOT_SPECIFIED };
